import state from "./state";

const getters = Object.keys(state).reduce((getters, key) => {
  getters[key] = (state) => state[key];
  return getters;
}, {});

const customGetter = {
  ...getters,
  imageStore() {
    return "https://storage.googleapis.com/";
  },
  dateFormated() {
    return (date, moment) => {
      if (moment(date).isValid()) {
        return moment(date).format("Do MMM YYYY HH:mm");
      } else {
        return "";
      }
    };
  },
  timeFormated() {
    return (date, moment) => {
      if (moment(date).isValid()) {
        return moment(date).format("HH:mm");
      } else {
        return "";
      }
    };
  },
  dayFormated() {
    return (date, moment, noTime = false) => {
      if (moment(date).isValid()) {
        if (noTime) {
          return moment(date).format("dddd, Do MMM YYYY");
        } else {
          return moment(date).format("dddd, Do MMM YYYY HH:mm");
        }
      } else if (date) {
        return date;
      } else {
        return "";
      }
    };
  },
  groupBy() {
    return (xs, key) => {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    };
  },
  isOwner() {
    return (idKaryawan, namaKaryawan) => {
      return !idKaryawan && !namaKaryawan;
    };
  },
};

export default customGetter;
